import React from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import FieldWrapper from '../FieldWrapper'

const TextArea = ({ displayName, description, errorMessage, disabled, value, onChange }) => {
  return (
    <FieldWrapper
      displayName={displayName}
      description={description} 
      errorMessage={errorMessage}
      disabled={disabled}
    >
      <div className="text-area-container">
        <textarea 
          type="text" 
          placeholder={displayName}
          value={value ?? ""}
          onChange={onChange ? (e) => onChange(e.target.value) : () => {}}
          disabled={disabled} 
        />
      </div>
    </FieldWrapper>
  )
}

TextArea.propTypes = {
  displayName: PropTypes.string,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
}

export default TextArea
